import { TRESPONSE_TNA_DEFAULT_STEPS, TTnAStepsDTO } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import { TTableRowNode } from '../../table.type';

export const TNA_DEFAULT_STEPS_TABLE_MODEL = {
  createModel: (items: TRESPONSE_TNA_DEFAULT_STEPS['steps']) => {
    return ModifiersZTableModel.createTableModel(
      items,
      {
        padding: 8,
        select: {
          position: 'START',
          isMulti: true,
          size: 'DEFAULT',
        },
        headerConfig: [
          {
            type: 'TEXT_CELL',
            text: 'STEPS',
            widthInPx: 200,
          },
          {
            type: 'TEXT_CELL',
            text: 'STAGE',
            widthInPx: 200,
          },
          {
            type: 'TEXT_CELL',
            text: 'CRITICAL',
            widthInPx: 200,
          },
        ],
      },
      (item): TTableRowNode<TTnAStepsDTO> => {
        return {
          type: 'ROW',
          rowItem: item,
          rowSelectionInfo: {
            isSelected: item.isRequired,
            isDisabled: item.isRequired,
            ...(item.isRequired && {
              disabledReason: 'These steps cannot be deleted and are pre-selected by default',
            }),
          },
          cells: [
            {
              type: 'TEXT_CELL',
              text: item.step,
            },
            {
              type: 'TEXT_CELL',
              text: item.stage,
            },
            {
              type: 'TEXT_CELL',
              text: String(item.isCritical),
            },
          ],
        };
      },
    );
  },
};
